import { useCallback, useState } from "react";

import { usePortalTranslation } from "./portal.js";

/** A phrase resolver captures event facts and evaluates its words in the current portal locale. */
export type PortalMessage = string | (() => string);

export function resolvePortalMessage(message: PortalMessage): string {
  return typeof message === "function" ? message() : message;
}

/** For displayed strings, records and arrays; a resolver preserves facts while rewording their copy. */
export function usePortalValue<T>(initial: T): readonly [T, (value: T | (() => T)) => void] {
  usePortalTranslation("core");
  const [stored, setStored] = useState<{ readonly resolve: () => T }>(() => ({ resolve: () => initial }));
  const setValue = useCallback((next: T | (() => T)) => {
    setStored({ resolve: typeof next === "function" ? next as () => T : () => next });
  }, []);
  return [stored.resolve(), setValue];
}

/** Keeps a displayed notice reactive without clearing form data or losing the event's facts. */
export function usePortalMessage(): readonly [string | null, (message: PortalMessage | null) => void] {
  return usePortalValue<string | null>(null);
}
